export const ApproachTabsContent = [
      {
        name: 'Virtual Reality',
        content: (
            <>
                <p>
                    Virtual reality provides an immersive, hands-on way to support training and workforce development. By placing learners in realistic, true-to-life environments, VR enables people in skilled labour industries to build skills, improve safety, and gain confidence before stepping into real-world situations. High-risk scenarios can be experienced and practiced without exposure to danger, helping workers prepare effectively while reducing on-the-job risk.
                </p>
            </>
        ),
    },

    {
        name: 'Augmented Reality',
        content: (
            <>
                <p>
                  We use augmented reality as a practical and adaptable medium for creating meaningful real-world experiences. Drawing on experience across a range of applications, we integrate digital information directly into physical environments to support effective learning, work, and problem-solving.
                </p>
                <p style={{ height: 'auto' }}>&nbsp;</p>
                <p>
                    
                </p>
            </>
        ),
    },
    {
        name: 'App & Software',
        content: (
            <>
                <p>
               We design and build end-to-end digital solutions across mobile, desktop, and web. From early concepts through deployment, our team develops scalable, production-ready software using modern technologies, with platforms and tools selected to fit each project's context and needs. Solutions can be deployed across iOS, Android, Windows, and Linux to support real-world use in learning, training, and applied environments.
                </p>
            </>
        ),
    },

    {
        name: 'Installations',
        content: (
            <>
                <p>
                  Interactive installations bring projects to life through meaningful engagement. We design and build experiences that invite audiences to explore, participate, and learn through thoughtfully applied technology, ranging from kiosks and touchscreens to game controllers and custom-built hardware. Each installation is tailored to its context, supporting learning, storytelling, or exploration in ways that enhance new or existing experiences.
                </p>
            </>
        ),
    },

    {
        name: 'Simulation',
        content: (
            <>
                <p>
                    We offer custom tailored simulations in a variety of real world situations. Leveraging AR/VR or multi-screen experiences, we can tailor to pre-existing HMI's or custom built solutions for new or existing products increasing fidelity to the simulated environment by imitating real-life processes giving new meaning to training experiences.
                </p>
            </>
        ),
    },
];
